// extracted by mini-css-extract-plugin
export default {"strong":"TopicsList_strong__tW7qU","wysiwyg":"TopicsList_wysiwyg__bSGVm"};